import script from "./LastItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LastItem.vue?vue&type=script&setup=true&lang=js"

import "./LastItem.vue?vue&type=style&index=0&id=7e4e05a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e4e05a4"]])

export default __exports__